import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isPerfEnabled, markNavigationStart, markSignificantRender } from "../perf/perfMonitor";

export function RuntimeRouteTelemetry() {
  const location = useLocation();

  useEffect(() => {
    if (!isPerfEnabled()) return undefined;
    const path = `${location.pathname}${location.search || ""}${location.hash || ""}`;
    markNavigationStart(path);
    let rafA = 0;
    let rafB = 0;
    rafA = window.requestAnimationFrame(() => {
      rafB = window.requestAnimationFrame(() => {
        markSignificantRender(path);
      });
    });
    return () => {
      if (rafA) window.cancelAnimationFrame(rafA);
      if (rafB) window.cancelAnimationFrame(rafB);
    };
  }, [location.pathname, location.search, location.hash]);

  return null;
}
